export default "__VITE_ASSET__CpsgRcYo__"